import Api from "@/services/AxiosService";
import { unwrap } from "./envelope";

const UPLOAD_TIMEOUT_MS = 300_000;

// General "Upload files" attachments on an application (NEW#3, POC parity).
// svc-06-quotation via gateway /v1/applications/:applicationId/files. Separate
// from the 3D STEP upload (svc-09); these are arbitrary supporting documents.
// Mirrors apps/web-customer/src/api/attachments.ts so both apps stay in sync.

export interface ApplicationAttachment {
  fileId: string;
  applicationId: string;
  fileName: string;
  kind: "attachment";
  mimeType: string | null;
  sizeBytes: number | null;
  uploadedAt: string | null;
  uploadedByEmail: string | null;
}

export async function listAttachments(
  applicationId: string,
): Promise<ApplicationAttachment[]> {
  const res = await Api.get(
    `/v1/applications/${encodeURIComponent(applicationId)}/files`,
  );
  return unwrap<ApplicationAttachment[]>(res.data);
}

export async function uploadAttachment(
  applicationId: string,
  file: File,
): Promise<ApplicationAttachment> {
  const form = new FormData();
  form.append("file", file);
  const res = await Api.post(
    `/v1/applications/${encodeURIComponent(applicationId)}/files`,
    form,
    { timeout: UPLOAD_TIMEOUT_MS },
  );
  return unwrap<ApplicationAttachment>(res.data);
}

export async function getAttachmentDownloadUrl(
  applicationId: string,
  fileId: string,
): Promise<{ url: string; fileName: string }> {
  const res = await Api.get(
    `/v1/applications/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}/download`,
  );
  return unwrap<{ url: string; fileName: string }>(res.data);
}

export async function deleteAttachment(
  applicationId: string,
  fileId: string,
): Promise<void> {
  await Api.delete(
    `/v1/applications/${encodeURIComponent(applicationId)}/files/${encodeURIComponent(fileId)}`,
  );
}
